import React, {FC} from 'react';

import {cn} from '@bem-react/classname';
import {Link} from '@gravity-ui/uikit';
import {AppInstallation} from 'common/constants';
import i18n from 'i18n';
import addQueryParams from 'ui/utils/addQueryParams';

import './Footer.scss';

const {
    YC: {
        routes: {yandexUrl, adminUrl, feedbackUrl, confidentialUrl},
        appInstallation,
        footer,
        iframe,
    },
} = window;

const cnFooter = cn('Footer');

const footerAdminUrl = addQueryParams(adminUrl, {
    utm_campaign:
        appInstallation === AppInstallation.External && iframe
            ? 'teaser_ext_experiment'
            : 'teaser_b',
});

export const currentYear = new Date().getFullYear();

const Footer: FC = () => {
    if (!footer) {
        return null;
    }

    return (
        <footer className={cnFooter('', {iframe})}>
            <div className={cnFooter('Link')}>
                {i18n(
                    'footer',
                    appInstallation === AppInstallation.Business
                        ? 'created-by-user-with'
                        : 'created-with',
                )}
                &nbsp;
                <Link href={footerAdminUrl} view="primary">
                    Yandex Forms
                </Link>
            </div>
            {!iframe && (
                <Link
                    href={feedbackUrl}
                    target="_blank"
                    view="primary"
                    className={cnFooter('Link')}
                >
                    {i18n('footer', 'link-feedback')}
                </Link>
            )}
            {appInstallation === AppInstallation.Business && !iframe && (
                <Link
                    href={confidentialUrl}
                    target="_blank"
                    view="primary"
                    className={cnFooter('Link')}
                >
                    {i18n('footer', 'link-confidential')}
                </Link>
            )}
            {!iframe && (
                <div className={cnFooter('Link')}>
                    ©&nbsp;
                    {currentYear}
                    &nbsp;
                    <Link href={yandexUrl} view="primary">
                        {i18n('footer', 'copyright')}
                    </Link>
                </div>
            )}
        </footer>
    );
};
export default Footer;
